import React, { useId } from "react";
import { Box, Dialog, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "../../context/Internationalization";

const MediaPreviewModal = ({ open, onClose, title, children, actions }) => {
  const { t } = useTranslation();
  const titleId = useId();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      aria-labelledby={titleId}
      PaperProps={{
        sx: {
          m: 2,
          width: "calc(100% - 32px)",
          maxWidth: 880,
          height: "min(680px, calc(100vh - 32px))",
          maxHeight: "calc(100vh - 32px)",
          "@supports (height: 100dvh)": {
            height: "min(680px, calc(100dvh - 32px))",
            maxHeight: "calc(100dvh - 32px)",
          },
          overflow: "hidden",
          borderRadius: 3,
        },
      }}
    >
      <DialogTitle
        id={titleId}
        sx={{
          flexShrink: 0,
          py: 2,
          pl: 3,
          pr: 8,
          typography: "h6",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        title={title || t("file")}
      >
        {title || t("file")}
      </DialogTitle>
      <IconButton
        aria-label={t("close")}
        onClick={onClose}
        sx={{ position: "absolute", top: 12, right: 12 }}
      >
        <CloseIcon />
      </IconButton>
      <Box
        sx={{
          flex: "1 1 0",
          minWidth: 0,
          minHeight: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 2, sm: 3 },
          pb: 2,
          overflow: "hidden",
          "& > img, & > video": {
            display: "block",
            width: "100%",
            height: "100%",
            minHeight: 0,
            objectFit: "scale-down",
            borderRadius: "8px",
          },
        }}
      >
        {children}
      </Box>
      {actions && (
        <Box
          sx={{
            flexShrink: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 1,
            px: { xs: 2, sm: 3 },
            pb: 2,
            maxHeight: "45%",
            overflowY: "auto",
          }}
        >
          {actions}
        </Box>
      )}
    </Dialog>
  );
};

export default MediaPreviewModal;
